module.controller('signupEnrollmentFeeScheduleCtrl', ['$scope', '$state', '$sce', '$window', function ($scope, $state, $sce, $window) {
  var vm = this;

  $window.scrollTo(0, 0);

  var urlRoot = window.location.href.split('#')[0];
  var currentBrand = $scope.brand.name;
  vm.trustSrc = function(src) {
    return $sce.trustAsResourceUrl(src);
  };

  function goTo(nextStep) {
    $state.go(nextStep, {joinType: $scope.joinType});
  }

  vm.goTo = goTo;
  vm.pdfSrc = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf';

  vm.openModal = function(){
    vm.showModal = true;
  };

  vm.closeModal = function(){
    vm.showModal = false;
  };

  vm.goToLogin = function(){
    $state.go('root.login');
  };
}]);
